(function (Drupal, once) {
  Drupal.behaviors.interactiveMap = {
    attach(context) {
      once('interactiveMap', '.interactive-map-wrapper', context).forEach(function (element) {
        const defalutSidebarItemTarget = element.querySelector(`[data-pin-id="world_region"]`);

        const mapAreaPins = element.querySelectorAll('[id$="region"]');
        const sidebarItems = element.querySelectorAll('[data-pin-id]');
        once('mapAreaPins', mapAreaPins).forEach((group) => {
          const pin = group.querySelector('.pin');
          const sidebarItemTarget = element.querySelector(`[data-pin-id="${group.id}"]`);

          const handleEvent = function () {
            const checkToggle = group.classList.contains('active');

            mapAreaPins.forEach((group) => {
              group.classList.remove('active');
            });
            sidebarItems.forEach((item) => item.classList.remove('active'));

            if (checkToggle) {
              defalutSidebarItemTarget.classList.add('active');
              group.querySelector('.pin').blur();
              return
            }

            group.classList.add('active');
            if (sidebarItemTarget) sidebarItemTarget.classList.add('active');
          };

          pin.addEventListener('click', handleEvent);
          pin.addEventListener('keypress', function (event) {
            if (event.key === 'Enter') handleEvent()
          })
        });

        element.addEventListener('click', (e) => {
          const clickableElements = ['rect', 'IMG', 'SPAN'];
          if (!clickableElements.includes(e.target.nodeName)) {
            mapAreaPins.forEach((group) => {
              group.classList.remove('active');
            });
            sidebarItems.forEach((item) => item.classList.remove('active'));
            defalutSidebarItemTarget.classList.add('active');
          }
        })
      });
    },
  };
})(Drupal, once);
